export default "__VITE_ASSET__CzVirW57__"